import auth from '@/services/api/auth'
import competition from '@/services/api/competition'
import templates from '@/services/api/templates'
import countries from '@/services/api/countries'
import user from '@/services/api/user'
import competitionMechanic from '@/services/api/competition-mechanic'
import workflow from '@/services/api/workflow'
import tag from '@/services/api/tag'
import attributesOptions from '@/services/api/attributes-options'
import attributesTypes from '@/services/api/attributes-types'
import service from '@/services/api/service'
import overview from '@/services/api/overview'

export default {
  auth,
  competition,
  templates,
  countries,
  user,
  competitionMechanic,
  attributesOptions,
  attributesTypes,
  workflow,
  tag,
  service,
  overview
}



// WEBPACK FOOTER //
// ./src/services/api.js